export const getDefaultMeta = () => ({
  current_page: 1,
  next_page: null,
  prev_page: null,
  total_count: 0,
  total_pages: 0,
});
